module.exports = __webpack_public_path__ + "static/media/pin_french_natural.4a41c66b.png";